import React from 'react';
import { Entity, LabelGraphics, ModelGraphics, PolygonGraphics } from 'resium';
import * as Cesium from 'cesium';
import * as DOMPurify from 'dompurify';
const GEO_FENCE_MODEL_URI = '/traffic_cone.glb';
function GeoFenceEntity({ geoFence, mission }) {
    DOMPurify.setConfig({ ALLOWED_TAGS: [] });
    const description = [`<table><tr><td>Name</th><td>${DOMPurify.sanitize(geoFence.name)}</td></tr>`];
    if (mission) {
        description.push(`<tr><td>Mission</th><td>${DOMPurify.sanitize(mission?.name)}</td></tr>`);
    }
    description.push('</table>');
    const points = geoFence.area?.at(0)?.slice(0, -1);
    if (!points) {
        return React.createElement(React.Fragment, null);
    }
    const lat = points.reduce((prev, curr) => prev + curr[1], 0) / points.length;
    const lng = points.reduce((prev, curr) => prev + curr[0], 0) / points.length;
    return (React.createElement(Entity, { position: Cesium.Cartesian3.fromDegrees(lng, lat, 0), name: "Geo fence", description: description.join('') },
        React.createElement(LabelGraphics, { text: geoFence.name, scale: 0.8, showBackground: true, backgroundColor: Cesium.Color.CRIMSON.withAlpha(0.5), backgroundPadding: new Cesium.Cartesian2(30, 10), eyeOffset: new Cesium.Cartesian3(0, 3, 0), horizontalOrigin: Cesium.HorizontalOrigin.CENTER, verticalOrigin: Cesium.VerticalOrigin.BOTTOM, outlineWidth: 5, outlineColor: Cesium.Color.CRIMSON }),
        React.createElement(PolygonGraphics, { hierarchy: { positions: Cesium.Cartesian3.fromDegreesArray(points.flatMap((e) => e)), holes: [] }, material: Cesium.Color.CRIMSON.withAlpha(0.25), extrudedHeight: 0, outline: true, outlineWidth: 5, outlineColor: Cesium.Color.CRIMSON }),
        React.createElement(ModelGraphics, { uri: GEO_FENCE_MODEL_URI, scale: 5, maximumScale: 10, minimumPixelSize: 32 })));
}
export default React.memo(GeoFenceEntity);
